{
  "title": "Konfigurationstester",
  "subtitle": "Was über den Mail-Pfad dieses Mandanten tatsächlich zutrifft, und was noch niemand geprüft hat.",
  "loadError": "Testergebnisse konnten nicht geladen werden",
  "runChecks": "Prüfungen ausführen",
  "pass": "Bestanden",
  "fail": "Fehlgeschlagen",
  "skip": "Nicht ausgeführt",
  "warn": "Warnung",
  "ignored": "Ignoriert",
  "history": "Ausführungsverlauf",
  "pasteReport": "Bericht einfügen",
  "pasteHint": "Fügen Sie die Ausgabe von Test-TenantMailFlow.ps1 ein, um Exchange-Connector-Nachweise zu hinterlegen.",
  "submitReport": "Bericht übermitteln",
  "groupDns": "DNS",
  "groupM365": "Microsoft 365",
  "groupGoogle": "Google Workspace",
  "groupMailPath": "Mail-Pfad",
  "noteDns": "Von hier aus geprüft, gegen öffentliches DNS über DNS-over-HTTPS. Das sind die Prüfungen, die die Plattform wirklich selbst durchführen kann.",
  "noteM365": "Exchange-Connectors und Transportregeln haben keine Graph-API, und dieser Build hat überhaupt keinen Graph-Client. Jede Antwort in dieser Gruppe stammt aus einem Test-TenantMailFlow.ps1-Bericht, den ein Operator eingefügt hat.",
  "noteGoogle": "Die Google-Workspace-Integration existiert in diesem Code noch nicht. Diese Zeilen sind da, damit diese Lücke sichtbar und nicht still ist — keine davon wird bestehen, bis die Integration gebaut ist.",
  "noteMailPath": "Die Plattform prüft sich selbst: ihren eigenen Listener, ihre eigenen Zertifikate, ihre eigene Snapshot-Zustellung.",
  "loopbackBlocking": "Smart-Host-Loopback schlägt fehl. Beheben Sie das, bevor Sie organisationsweit freigeben — ausgehende Mail würde bounce.",
  "loopbackTitle": "Smart Host löst zu Loopback auf",
  "checkedAge": "Geprüft vor {{age}}.",
  "checksFailedTitle": "{{count}} Prüfungen fehlgeschlagen",
  "checksFailedBody": "Eine fehlgeschlagene Prüfung bedeutet, dass der Mail-Pfad dieses Mandanten jetzt falsch konfiguriert ist, nicht dass er später falsch sein könnte. Verwenden Sie Ignorieren bei einer Zeile nur, wenn der Fehler bekannter Rauschen für diesen Mandanten ist.",
  "checksSkippedTitle": "{{count}} Prüfungen wurden nicht ausgeführt",
  "checksSkippedBody": "Dieser Mandant ist nicht verifiziert. Die unten als „nicht ausgeführt“ markierten Prüfungen haben überhaupt kein Ergebnis — sie bestehen nicht stillschweigend, und aus ihrem Fehlen sollte nur gelesen werden, dass niemand hingesehen hat.",
  "ignore": "Ignorieren",
  "unignore": "Nicht mehr ignorieren",
  "sourceAutomated": "Automatisiert",
  "sourcePasted": "Eingefügter Bericht",
  "sourceServer": "Server",
  "sourceUnknown": "Unbekannt",
  "provenancePasted": "eingefügt",
  "provenanceSkipped": "in einem Lauf übersprungen",
  "provenanceChecked": "geprüft",
  "groupNothingRan": "Nichts in dieser Gruppe wurde geprüft. Diese Zeilen bestehen nicht stillschweigend — sie wurden nie ausgeführt.",
  "groupNoResults": "Noch keine Ergebnisse. Führen Sie diese Gruppe aus, oder fügen Sie einen Bericht ein, der sie abdeckt.",
  "tookMs": "Dauerte {{ms}} ms.",
  "ignoreHintFail": "Schließt diesen Fehler aus Zählungen und Gates aus. Übersteht erneute Läufe.",
  "ignoreHintWarn": "Schließt diese Warnung aus Zählungen und Gates aus. Übersteht erneute Läufe.",
  "pasteTitle": "Test-TenantMailFlow-Bericht einfügen",
  "pasteIntro": "Bevorzugen Sie oben Automatisierte Validierung ausführen, wenn die Connector-App Exchange erreichen kann. Einfügen bleibt der Notfallweg: führen Sie dies in einer mit dem Kunden verbundenen Exchange-Online-Sitzung aus und fügen Sie das ausgegebene JSON ein.",
  "scriptTitle": "Test-TenantMailFlow.ps1",
  "scriptDescription": "Nur lesend. Prüft lebendes öffentliches DNS über DNS-over-HTTPS statt des Resolvers der Maschine, damit eine Split-Horizon-Antwort nicht beruhigend wirkt.",
  "reportJson": "Bericht-JSON",
  "reportJsonDescription": "Alles von der öffnenden bis zur schließenden geschweiften Klammer.",
  "reportJsonPlaceholder": "{ \"Organization\": \"contoso.onmicrosoft.com\", \"Checks\": [ ... ] }",
  "reportInvalidTitle": "Dieser Bericht kann nicht abgelegt werden",
  "reportCompleteTitle": "Bericht sieht vollständig aus",
  "reportSummary": "{{checks}} Prüfungen von {{organization}}, ausgeführt {{when}}: {{pass}} bestanden, {{warn}} Warnungen, {{fail}} fehlgeschlagen, {{skip}} nicht ausgeführt.",
  "fileError": "Bericht konnte nicht abgelegt werden",
  "fileReport": "Diesen Bericht ablegen",
  "filed": "Bericht für diesen Mandanten abgelegt.",
  "filePermissionHint": "Ein abgelegter Bericht wird zum Nachweis dieses Mandanten, daher können Mandantenadministratoren und höher einen ablegen. Den Befehl auszuführen und die Ausgabe zu lesen erfordert keine Rolle.",
  "historyWhen": "Wann",
  "historySource": "Quelle",
  "historyResult": "Ergebnis",
  "historyEmpty": "Dieser Mandant wurde noch nie getestet.",
  "historyPass": "{{count}} bestanden",
  "historyWarn": "{{count}} Warnungen",
  "historyFail": "{{count}} fehlgeschlagen",
  "historySkip": "{{count}} nicht ausgeführt"
}
